/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Table_Move_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to move: {error}" |
*
* @param {Explorer_Table_Move_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_move_failed_toast = /** @type {((inputs: Explorer_Table_Move_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Move_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du deplacement : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Verschiebung fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile spostare: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось переместиться: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo mover: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`移动失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`移動に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्थानांतरण विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao mover: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to move: ${i?.error}`)
});